import { useMutation } from '@tanstack/react-query'
import { startAuthentication, type PublicKeyCredentialRequestOptionsJSON } from '@simplewebauthn/browser'
import { apiFetch, apiJson } from '../api/client'

export function useStepUp() {
  const mutation = useMutation({
    mutationFn: async () => {
      // 1. Get challenge from backend
      const { publicKey } = await apiJson<{ publicKey: PublicKeyCredentialRequestOptionsJSON }>(
        '/auth/step-up/begin',
        { method: 'POST' },
      )

      // 2. Prompt user for WebAuthn assertion
      const assertion = await startAuthentication({ optionsJSON: publicKey })

      // 3. Send assertion to backend for verification
      const response = await apiFetch('/auth/step-up/complete', {
        method: 'POST',
        body: JSON.stringify(assertion),
      })

      if (!response.ok) {
        const body = await response.text()
        throw new Error(body || 'Step-up verification failed')
      }
    },
  })

  return {
    /** 'idle' | 'pending' | 'success' | 'error' */
    status: mutation.status,
    error: mutation.error?.message ?? null,
    performStepUp: mutation.mutateAsync,
    reset: mutation.reset,
  }
}
